import { Button, Modal } from 'antd';

const ConfirmModal = ({ open, onOk, onCancel, textComponent, confirmBtnProps, confirmBtnTitle }) => {

  return (
    <Modal
      title={'Potrdi'}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>Prekliči</Button>,
        <Button key="confirm" type="primary" onClick={() => onOk()} {...confirmBtnProps} >{confirmBtnTitle}</Button>
      ]}
    >
        {textComponent}
    </Modal>
  );
};

export default ConfirmModal;
